import React, { Component } from "react";
import {
  Form,
  Grid,
  Button,
  Dropdown,
  Search,
  Label,
  Segment,
  Header,
  Icon,
  Input,
  Divider,
} from "semantic-ui-react";
import Feathers from "../../redux/FeathersRedux";
import { notify } from "react-notify-toast";
import swal from "sweetalert2";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import moment from "moment";
import { nanoid } from "nanoid";
import Config from "../../config";
import feathersRestClient from "@feathersjs/rest-client";
import feathers from "@feathersjs/feathers";
import axios from "axios";

const renderCodeSearchResults = ({ id, code }) => (
  <Label key={id} content={code} />
);

const REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class ProviderEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      provider: {
        nombre: "",
        email: "",
        telefono: "",
        rfc: "",
        direccion: "",
        n_interior: "",
        n_exterior: "",
        colonia: "",
        ciudad: "",
        cp: "",
        estado: "",
        pais: "",
        url_web: "",
        moneda_id: null,
      },
      loading: false,
      error: false,
      moneda_options: [],
      rawMaterials: [],
      options: [],
      codeResults: null,
      code: null,
      codeLoadings: false,
      tipo_tarea_id: null,
      tipos_tarea: [],
    };
  }

  fetchTiposTarea = async () => {
    await Feathers.service("tipo_tarea")
      .find({
        query: {
          $limit: "-1",
        },
      })
      .then((tipos_tarea) => {
        this.setState({
          tipos_tarea: tipos_tarea.map((t) => {
            return {
              value: t.id,
              text: t.nombre,
            };
          }),
        });
      });
  };

  componentDidMount() {
    this.fetchTiposTarea();
    this.fetchMonedaOptions();
    this.fetchData();
    this.fetchRawMaterials();
  }

  fetchData = () => {
    this.setState(
      {
        loading: true,
      },
      () => {
        Feathers.service("proveedor")
          .find({
            query: {
              id: this.props.match.params.id,
              activo: 1,
            },
          })
          .then((response) => {
            const res = response.data[0];
            this.setState({
              provider: {
                ...this.state.provider,
                nombre: res.nombre,
                email: res.email,
                telefono: res.telefono,
                rfc: res.rfc,
                direccion: res.direccion,
                n_interior: res.n_interior,
                n_exterior: res.n_exterior,
                colonia: res.colonia,
                ciudad: res.ciudad,
                cp: res.cp,
                estado: res.estado,
                pais: res.pais,
                moneda_id: res.moneda_id,
                nombre_contacto: res.nombre_contacto,
                whatsapp_telefono: res.whatsapp_telefono,
                puesto_contacto: res.puesto_contacto,
                fecha_nacimiento: res.fecha_nacimiento,
                codigos_iso_id: res.codigos_iso_id,
                url_web: res.url_web,
                iso_document: null,
              },
              code: res.codigos_iso,
            });
          })
          .catch((err) => {
            this.setState({ loading: false });
          });
      }
    );

    this.setState(
      {
        loading: true,
      },
      () => {
        Feathers.service("proveedor_materias")
          .find({
            query: {
              proveedor_id: this.props.match.params.id,
            },
          })
          .then((res) => {
            let provider_rawmaterials = res.data.map((v, i) => {
              return v.materia_id;
            });

            this.setState({
              rawMaterials: provider_rawmaterials,
              loading: false,
            });
          })
          .catch((err) => {
            this.setState({ loading: false });
          });
      }
    );
  };

  // setTiposTarea = async (value) => {
  //   this.setState({
  //     tipo_tarea_id: value,
  //   });
  // };

  fetchRawMaterials = () => {
    this.setState(
      {
        loading: true,
      },
      () => {
        Feathers.service("materia_prima")
          .find({
            query: {
              activo: 1,
              doPagination: false,
            },
          })
          .then((res) => {
            let options = res.map((v, i) => {
              return {
                key: i,
                text: `${v.nombre} - ${v.codigo}`,
                value: v.id,
              };
            });
            this.setState({
              options,
            });
          })
          .catch((err) => {
            this.setState({ loading: false });
          });
      }
    );
  };

  fetchMonedaOptions = async (_) => {
    let options = await Feathers.service("moneda").find({
      query: {
        $limit: "-1",
      },
    });

    let moneda_options = options.map((v) => {
      return {
        key: v.id,
        value: v.id,
        text: v.nombre + " / " + v.cod,
      };
    });

    this.setState({
      moneda_options,
    });
  };

  handleSubmit = () => {
    if (!this.state.provider.nombre) {
      notify.show("El provider debe llevar un nombre", "error", 2000);
      return;
    }

    if (!this.state.provider.email) {
      notify.show("El provider debe llevar un email", "error", 2000);
      return;
    }

    if (!REGEX.test(this.state.provider.email)) {
      notify.show("Ingresa un email válido", "error", 2000);
      return;
    }

    this.setState(
      {
        loading: true,
      },
      () => {
        Feathers.service("proveedor")
          .patch(this.props.match.params.id, {
            nombre: this.state.provider.nombre,
            email: this.state.provider.email,
            telefono: this.state.provider.telefono,
            rfc: this.state.provider.rfc,
            direccion: this.state.provider.direccion,
            n_interior: this.state.provider.n_interior,
            n_exterior: this.state.provider.n_exterior,
            colonia: this.state.provider.colonia,
            ciudad: this.state.provider.ciudad,
            cp: this.state.provider.cp,
            estado: this.state.provider.estado,
            pais: this.state.provider.pais,
            moneda_id: this.state.provider.moneda_id,
            rawMaterials: this.state.rawMaterials,
            nombre_contacto: this.state.provider.nombre_contacto,
            whatsapp_telefono: this.state.provider.whatsapp_telefono,
            puesto_contacto: this.state.provider.puesto_contacto,
            fecha_nacimiento: this.state.provider.fecha_nacimiento,
            url_web: this.state.provider.url_web,
            codigo_iso_id: this.state.code ? this.state.code.id : null,
          })
          .then(async (res) => {
            //this.props.onCreate();
            await this.uploadFile().finally(() => {
              swal({
                title: "Actualización exitosa",
                type: "success",
                confirmButtonText: "ok",
                reverseButtons: true,
              }).then((res) => {
                this.setState({
                  loading: false,
                });
              });
            });
          })
          .catch((err) => {
            console.log(err, "el error");
            swal({
              title: "Se produjo un error, intente de nuevo.",
              type: "error",
              confirmButtonText: "ok",
              reverseButtons: true,
            }).then((res) => {
              this.setState({ loading: false });
            });
          });
      }
    );
  };

  handleCodeSearchChange = (e, { value }) => {
    this.setState({ codeLoadings: true, code: value });

    setTimeout(() => {
      if (this.state.code.length < 1) return this.resetCodeComponent();

      Feathers.service("codigos_iso")
        .find({
          query: {
            code: { $like: `%${value}%` },
            activo: 1,
          },
        })
        .then((res) => {
          this.setState({
            codeLoadings: false,
            codeResults: res.data,
          });
        });
    }, 500);
  };

  handleCodeResultSelect = async (e, { result }) => {
    this.setState({ code: result });

    await this.setState({
      filterOptions: {
        ...this.state.filterOptions,
        id: result.id,
      },
    });
  };

  uploadFile = async () => {
    // const idFolder = this.state.tipo_tarea_id;
    const idFolder = 4;
    let newDataToSend = new FormData();
    if (
      document.getElementById("documentFile") &&
      document.getElementById("documentFile").files.length > 0 &&
      document.getElementById("documentFile").files[0]
    ) {
      let form = document.getElementById("documentFile").files[0];
      newDataToSend.set("documentFile", form);
    } else {
      swal({
        title: "No ha seleccionado ningún archivo",
        type: "warning",
        confirmButtonText: "OK",
        reverseButtons: true,
      });
      return;
    }

    const today = moment().format("YYYY-MM-DD");
    const currentTime = moment().format("HH:mm:ss");

    const clave = nanoid(10);

    this.setState({ loading: true });
    try {
      const nuevaTarea = await Feathers.service("calendario_tarea").create({
        clave: clave,
        titulo: "VERIFICACIÓN PROVEEDOR",
        descripcion: "VERIFICACIÓN PROVEEDOR",
        fecha_creacion: today,
        allDay: false,
        fecha_inicio: today,
        hora_inicio: currentTime,
        fecha_fin: today,
        hora_fin: currentTime,
        perfil_usuario_id: this.props.user.perfil_id || null,
        usuario_id: this.props.user.id,
        tipo_tarea_id: idFolder,
        maquina_mantenimiento_id: null,
        tipo_mantenimiento_id: null,
        tiene_periodicidad: false,
        periodicidad_id: null,
        status_tarea_id: 3,
        entregable: true,
        descripcion_entregable: null,
        codigo_iso_id: this.state.code.id,
        fecha_fin_usuario: today,
      });

      newDataToSend.set("folder_id", idFolder);
      newDataToSend.set("tarea_calendario_id", nuevaTarea.id);
      const token = localStorage.getItem("bingham-jwt");
      const app = feathers();
      const restClient = feathersRestClient(Config.apiUrl);
      app.configure(restClient.axios(axios));

      app
        .service("tarea_file")
        .create(newDataToSend, {
          headers: {
            Authorization: token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          if (document.getElementById("documentFile")) {
            document.getElementById("documentFile").value = null;
          }
          swal({
            title: "¡Subida Exitosa!",
            type: "success",
            confirmButtonText: "OK",
          }).then((res) => {
            this.setState({ loading: false });
          });
        })
        .catch((err) => {
          alert("Se produjo un error");
          console.log(err, "error");
          console.log(this.state, "mi error");
          this.setState({
            loading: false,
          });
        });
    } catch (err) {
      console.error("Error al crear tarea o subir archivo:", err);
      swal({
        title: "Error al crear tarea o subir archivo",
        type: "error",
        confirmButtonText: "OK",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    return (
      <div>
        <Grid>
          <Grid.Row columns={1}>
            <Grid.Column>
              <Header as={"h2"}>
                <Button
                  onClick={() => this.props.dispatch(push("/providers"))}
                  icon="arrow left"
                  style={{ backgroundColor: "transparent", color: "#000000" }}
                />
                Editar Proveedor
              </Header>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider />
        <Form size={"large"}>
          <Grid>
            <Grid.Row columns={2} divided>
              <Grid.Column>
                <Grid.Row>
                  <Form.Input
                    label="Nombre/Razón social"
                    name="nombre"
                    value={this.state.provider.nombre}
                    type="text"
                    placeholder="Nombre/Razón social"
                    onChange={(e, { name, value }) =>
                      this.setState({
                        provider: { ...this.state.provider, [name]: value },
                      })
                    }
                    required
                  />
                  <Form.Input
                    type="email"
                    label="Email"
                    name="email"
                    value={this.state.provider.email}
                    placeholder="Email"
                    onChange={(e, { name, value }) =>
                      this.setState({
                        provider: { ...this.state.provider, [name]: value },
                      })
                    }
                    required
                  />
                  <Form.Input
                    label="Teléfono"
                    name="telefono"
                    value={this.state.provider.telefono}
                    type="text"
                    placeholder="Teléfono"
                    onChange={(e, { name, value }) =>
                      this.setState({
                        provider: { ...this.state.provider, [name]: value },
                      })
                    }
                  />
                  <Form.Input
                    label="RFC"
                    name="rfc"
                    value={this.state.provider.rfc}
                    type="text"
                    placeholder="RFC"
                    onChange={(e, { name, value }) =>
                      this.setState({
                        provider: { ...this.state.provider, [name]: value },
                      })
                    }
                  />
                  <Form.Dropdown
                    label="Moneda"
                    value={this.state.provider.moneda_id}
                    options={this.state.moneda_options}
                    selection
                    placeholder={"Moneda"}
                    onChange={(_, d) => {
                      this.setState({
                        provider: {
                          ...this.state.provider,
                          moneda_id: d.value,
                        },
                      });
                    }}
                  />
                  <Form.Input label="Materias primas">
                    <Dropdown
                      placeholder="Seleccione las materias primas de este proveedor"
                      fluid
                      multiple
                      selection
                      search
                      options={this.state.options}
                      value={this.state.rawMaterials}
                      onChange={(e, { value }) =>
                        this.setState({
                          error: false,
                          rawMaterials: [...value],
                        })
                      }
                    />
                  </Form.Input>
                  <Form.Input
                    label="Dirección"
                    name="direccion"
                    type="text"
                    placeholder="Dirección"
                    value={this.state.provider.direccion}
                    onChange={(e, { name, value }) =>
                      this.setState({
                        provider: { ...this.state.provider, [name]: value },
                      })
                    }
                  />
                  <Form.Group>
                    <Form.Input
                      label="No. interior"
                      value={this.state.provider.n_interior}
                      name="n_interior"
                      placeholder="No. interior"
                      width={8}
                      onChange={(e, { name, value }) =>
                        this.setState({
                          provider: { ...this.state.provider, [name]: value },
                        })
                      }
                    />
                    <Form.Input
                      label="No. exterior"
                      value={this.state.provider.n_exterior}
                      name="n_exterior"
                      placeholder="No. exterior"
                      width={8}
                      onChange={(e, { name, value }) =>
                        this.setState({
                          provider: { ...this.state.provider, [name]: value },
                        })
                      }
                    />
                  </Form.Group>
                </Grid.Row>
              </Grid.Column>
              <Grid.Column>
                <Grid.Row>
                  <Form.Input
                    label="Colonia"
                    value={this.state.provider.colonia}
                    name="colonia"
                    type="text"
                    placeholder="Colonia"
                    onChange={(e, { name, value }) =>
                      this.setState({
                        provider: { ...this.state.provider, [name]: value },
                      })
                    }
                  />
                  <Form.Group>
                    <Form.Input
                      label="Ciudad"
                      value={this.state.provider.ciudad}
                      name="ciudad"
                      placeholder="Ciudad"
                      width={8}
                      onChange={(e, { name, value }) =>
                        this.setState({
                          provider: { ...this.state.provider, [name]: value },
                        })
                      }
                    />
                    <Form.Input
                      label="C.P."
                      value={this.state.provider.cp}
                      name="cp"
                      placeholder="C.P."
                      width={8}
                      onChange={(e, { name, value }) =>
                        this.setState({
                          provider: { ...this.state.provider, [name]: value },
                        })
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Input
                      label="Estado"
                      value={this.state.provider.estado}
                      name="estado"
                      placeholder="Estado"
                      width={8}
                      onChange={(e, { name, value }) =>
                        this.setState({
                          provider: { ...this.state.provider, [name]: value },
                        })
                      }
                    />
                    <Form.Input
                      label="País"
                      value={this.state.provider.pais}
                      name="pais"
                      placeholder="País"
                      width={8}
                      onChange={(e, { name, value }) =>
                        this.setState({
                          provider: { ...this.state.provider, [name]: value },
                        })
                      }
                    />
                    <Form.Input
                      label="Pagína Web"
                      value={this.state.provider.url_web}
                      name="url_web"
                      placeholder="Página web"
                      width={8}
                      onChange={(e, { name, value }) =>
                        this.setState({
                          provider: { ...this.state.provider, [name]: value },
                        })
                      }
                    />
                  </Form.Group>
                  <Form.Field>
                    <label>Codigo ISO:</label>
                    <Search
                      loading={this.state.codeLoadings}
                      value={this.state.code ? this.state.code.code : ""}
                      results={this.state.codeResults || []}
                      onResultSelect={this.handleCodeResultSelect}
                      onSearchChange={this.handleCodeSearchChange}
                      resultRenderer={renderCodeSearchResults}
                      placeholder="Código"
                      className="full-width"
                    />
                  </Form.Field>
                  {/* <Form.Dropdown
                    label="Tipo de tarea "
                    placeholder="Seleccione una opción"
                    selection
                    search
                    onChange={(e, { name, value }) => this.setTiposTarea(value)}
                    options={this.state.tipos_tarea}
                  /> */}
                  {this.state.provider && (
                    <Form.Field>
                      <label>Documento de Código ISO:</label>
                      <Segment placeholder textAlign="center" padded>
                        <Grid.Row>
                          <Header icon as="h3">
                            <Icon name="pdf file outline" />
                            El documento que suba se guardará en la carpeta
                            Varios
                          </Header>
                        </Grid.Row>
                        <Grid
                          textAlign="center"
                          style={{ width: "50%", margin: "0 auto" }}
                        >
                          <Grid.Row columns={2}>
                            <Grid.Column width={10}>
                              <Input
                                accept="application/pdf"
                                type="file"
                                id="documentFile"
                                name="document"
                                onChange={(event) => {
                                  if (
                                    event.target.files &&
                                    event.target.files.length > 0
                                  ) {
                                    this.setState({
                                      document: event.target.files[0],
                                    });
                                  }
                                }}
                              />
                            </Grid.Column>
                            <Grid.Column width={20}>
                              <Button
                                loading={this.state.loading}
                                onClick={this.uploadFile}
                                disabled={!this.state.code}
                                floated="center"
                                color="blue"
                                labelPosition="left"
                                icon="upload"
                                content="Subir"
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Segment>
                    </Form.Field>
                  )}
                </Grid.Row>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column floated="right" width={5}>
                <Button
                  disabled={this.state.loading}
                  loading={this.state.loading}
                  type="button"
                  onClick={this.handleSubmit}
                  floated="right"
                  positive
                  content="REGISTRAR"
                  icon="send"
                  labelPosition="left"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps, null, null, {
  withRef: true,
})(ProviderEdit);
